import {Pipe} from '@angular/core';

@Pipe({name: 'round'})
export class RoundPipe {
  transform (input:number) {
    return Math.floor(input);
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/rounded.pipes.ts